<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <div v-if="isRwd && !isDisabled && isCancelClick">
      <div class="grid line-text line-set mt-3">
        <div class="col-12 lg:col-4">
          <label for="rewardType" class="control-labeladd">
            {{ staticData.rewards.rwdtype }}
          </label>
        </div>
        <div class="col-12 lg:col-8">
          <div class="border-box">
            <PrimeButton
              v-if="vmodel1.ambshowVoyadoPromo"
              label="Voyado Promotion"
              class="rwd-btn"
              @click="changeEventofUseDynamicCode(2)"
              :class="{ 'active-btn': vmodel1.ambRewardtype === 2 }"
              id="voyado-promotion"
              :disabled="dealStatus != 3"
              :value="3"
            ></PrimeButton>
            <PrimeButton
              v-if="vmodel1.ambshowVoyadoPromo"
              label="Voyado bonus points"
              class="rwd-btn1"
              @click="changeEventofUseDynamicCode(3)"
              :class="{ 'active-btn': vmodel1.ambRewardtype === 3 }"
              id="voyado-bonus"
              :disabled="dealStatus != 3"
              :value="2"
            ></PrimeButton>
            <PrimeButton
              label="Unique Code"
              class="rwd-btn1"
              @click="changeEventofUseDynamicCode(1)"
              :class="{ 'active-btn': vmodel1.ambRewardtype === 1 }"
              id="unique-code"
              :disabled="dealStatus != 3"
              :value="1"
            ></PrimeButton>
            <PrimeButton
              label="Static Code"
              class="rwd-btn1"
              @click="changeEventofUseDynamicCode(0)"
              :class="{ 'active-btn': vmodel1.ambRewardtype === 0 }"
              id="static-code"
              :disabled="dealStatus != 3"
              :value="0"
            ></PrimeButton>
          </div>
        </div>
      </div>

      <div class="border-line mt-3"></div>

      <div class="grid mt-2 line-text" v-if="vmodel1.ambRewardtype == 2">
        <div class="col-12 lg:col-7">
          <label for="Voyadopromotion" class="control-labeladd" v-tooltip>
            {{ lmodel.ambVoyadoPromo }}
          </label>
        </div>
        <div class="col-12 lg:col-5 mb-2">
          <InputRequiredText
            id="ambvoyadoPromotionId"
            v-model="vmodel1.ambVoyadoPromoId"
            :validation="valmodel.ambVoyadoPromoId"
            :placeholder="lmodel.ambVoyadoPromoIdPlaceHolder"
            :PropName="lmodel.ambVoyadoPromo"
          ></InputRequiredText>
        </div>
      </div>

      <div class="grid mt-2 line-text" v-if="vmodel1.ambRewardtype == 3">
        <div class="col-12 lg:col-7">
          <label for="Voyadobonus" class="control-labeladd" v-tooltip>
            {{ lmodel.ambVoyadoBonusPoint }}
          </label>
        </div>
        <div class="col-12 lg:col-5 mb-2">
          <InputRequiredText
            id="Ambbonusno111"
            v-model="vmodel1.ambvoyadobonuspoint"
            :validation="valmodel.ambvoyadobonuspoint"
            :placeholder="lmodel.ambVoyadoBonusPointPlaceHolder"
            :PropName="lmodel.ambVoyadoBonusPoint"
          ></InputRequiredText>
        </div>
      </div>

      <div v-if="vmodel1.ambRewardtype == 1">
        <div class="grid mt-2 line-text">
          <div class="col-12 lg:col-7">
            <label for="Voyadobonus" class="control-labeladd" v-tooltip>
              {{ lmodel.ambCustomCode }}
              <!-- {{ vmodel1.ambCustomerCodesUpdate }} -->
            </label>
          </div>
        </div>
        <div class="grid mt-2 line-text">
          <div class="col-12 lg:col-5">
            <label
              for="ambCustomCodeFile-tooltip"
              class="control-labeladd"
              :isRequiredLabel="true"
              >{{ lmodel.ambCustomCodeFile }}</label
            >
            <div>
              <FileUpload
                ref="file"
                type="file"
                id="fontfileupload"
                mode="basic"
                accept=".csv"
                @select="handleDynamicCodes($event)"
                class="browse-button w-full"
                :class="{
                  'p-invalid': !valmodel.ambCustomerDynamicCodesActualFilename,
                }"
              />
              <span
                v-if="
                  valmodel.ambCustomerDynamicCodesActualFilename &&
                  valmodel.ambCustomerDynamicCodesActualFilename.$error
                "
                class="p-error"
                >File Upload is required</span
              >
              <span
                v-if="vmodel1.ambdynamicCodesFileListItems"
                style="float: right"
              >
                <Dropdown
                  v-model="uniquecodedropdown"
                  :options="vmodel1.ambdynamicCodesFileListItems"
                  id="npsType"
                  class="mt-2"
                  style="width: 158px"
                  optionLabel="text"
                  optionValue="value"
                  dropdownIcon="fa fa-sort"
                  editable
                  @change="downloadCSV"
                ></Dropdown>
              </span>
            </div>
          </div>
          <div class="col-12 lg:col-2"></div>
          <div
            class="col-12 lg:col-5"
            v-if="
              ($store.state.cognitoInfo.role == 'Superadmin' || 'Admin') &&
              $route.name !== 'ManageDealUpdateCreate'
            "
          >
            <label
              for="ambCustomReplaceCodeFile-tooltip"
              class="control-labeladd"
              :isRequiredLabel="true"
              >{{ lmodel.ambCustomReplaceCodeFile }}</label
            >
            <div>
              <FileUpload
                ref="file1"
                type="file"
                id="fontfileupload1"
                mode="basic"
                accept=".csv"
                @select="replaceDynamicCodes($event)"
                class="browse-button w-full"
              />
              <span v-if="replacefiledropdown" style="float: right">
                <Dropdown
                  v-model="replacefiledropdown"
                  :options="vmodel1.ambreplacefiles"
                  id="npsType"
                  style="width: 158px"
                  class="mt-2"
                  optionLabel="text"
                  optionValue="value"
                  dropdownIcon="fa fa-sort"
                  editable
                  @change="downloadCSVreplacefile"
                ></Dropdown>
              </span>
            </div>
          </div>
        </div>
        <div class="grid mt-2 line-text">
          <div class="col-12 lg:col-5">
            <label
              for="ambLowCodeLimit-tooltip"
              class="control-labeladd"
              :isRequiredLabel="true"
              >{{ lmodel.ambLowCodeLimit }}</label
            >
            <InputRequiredNumber
              :validation="valmodel.ambCustomerLowCodeLimit"
              v-model="vmodel1.ambCustomerLowCodeLimit"
              id="ambCustomerLowCodeLimit"
              PropName="Low code Limit"
              :placeholder="lmodel.ambLowCodeLimitPlaceholder"
              MinValue="0"
              MaxValueProp="Customer Code"
            ></InputRequiredNumber>
          </div>
          <div class="col-12 lg:col-2"></div>
          <div class="col-12 lg:col-5">
            <label
              for="ambLowCodeAlertLimit-tooltip"
              class="control-labeladd"
              :isRequiredLabel="true"
              >{{ lmodel.ambLowCodeAlertLimit }}</label
            >
            <InputRequiredNumber
              v-model="vmodel1.ambCustomerLowCodeAlertLimit"
              :validation="valmodel.ambCustomerLowCodeAlertLimit"
              id="CustomerLowCodeAlertLimit"
              PropName="Low code alert"
              :placeholder="lmodel.ambLowCodeAlertLimitPlaceholder"
              MinValue="0"
              MaxValueProp="Customer Code"
            ></InputRequiredNumber>
          </div>
          <div class="col-12 lg:col-7"></div>
          <div class="col-12 lg:col-5">
            <div class="custom-control">
              <Checkbox
                :binary="true"
                v-model="vmodel1.ambshowdeniedoutofcodemsg"
                id="showdeniedoutofcodemsg"
                type="checkbox"
              />
              <label
                for="showdeniedoutofcodemsg"
                class="ml-2 checkbox-radio-font"
                id="showdeniedoutofcodemsg-tooltip"
                v-tooltip="lmodel.ambShowdeniedoutofcodemsgToolTip"
                >{{ lmodel.ambShowdeniedoutofcodemsg }}</label
              >
            </div>
          </div>
          <div v-if="vmodel1.ambshowdeniedoutofcodemsg" class="col-12 lg:col-5">
            <label
              v-tooltip="lmodel.ambOutofcodemsgtitleToolTip"
              for="ambOutofcodemsgtitle-tooltip"
              class="control-labeladd"
              :isRequiredLabel="true"
              >{{ lmodel.ambOutofcodemsgtitle }}</label
            >
            <InputRequiredText
              :validation="valmodel.amboutofcodemsgtitle"
              v-model="vmodel1.amboutofcodemsgtitle"
              id="amboutofcodemsgtitle"
              :PropName="lmodel.ambOutofcodemsgtitle"
              :placeholder="lmodel.ambOutofcodemsgtitlePlaceholder"
            ></InputRequiredText>
          </div>
          <div class="col-12 lg:col-2"></div>
          <div v-if="vmodel1.ambshowdeniedoutofcodemsg" class="col-12 lg:col-5">
            <label
              for="AmbOutofcodemsgbody-tooltip"
              class="control-labeladd"
              :isRequiredLabel="true"
              >{{ lmodel.ambOutofcodemsgbody }}</label
            >
            <InputRequiredText
              :validation="valmodel.amboutofcodemsgbody"
              v-model="vmodel1.amboutofcodemsgbody"
              id="amboutofcodemsgbody"
              :PropName="lmodel.ambOutofcodemsgbody"
              :placeholder="lmodel.ambOutofcodemsgbodyPlaceholder"
            ></InputRequiredText>
          </div>
          <!-- <div class="col-12 lg:col-5">
            <div
              v-if="isStaticCode"
              class="col-12 lg:col-6"
              :class="{ redeal_disabled: vmodel.isEnableRewardCode == false }"
            >
              <label
                for="friCodeLimit-tooltip"
                class="control-labeladd"
                :isRequiredLabel="true"
                >{{ lmodel.friCodeLimit }}</label
              >
              <InputRequiredNumber
                v-model="vmodel1.friendCodeLimit"
                id="FriendCodeLimit"
                PropName="Codes Per Ambassador"
                :placeholder="lmodel.friCodeLimitPlaceholder"
                MinValue="0"
              ></InputRequiredNumber>
            </div>
          </div> -->
        </div>
      </div>
      <!-- Static code -->
      <div v-if="vmodel1.ambRewardtype == 0">
        <div class="grid mt-2 line-text">
          <div class="col-12 lg:col-7">
            <label for="staticCode" class="control-labeladd" v-tooltip>
              {{ lmodel.ambStaticCode }}
            </label>
          </div>
          <div class="col-12 lg:col-5">
            <label
              for="ambEnterStaticCode-tooltip"
              class="control-labeladd"
              :isRequiredLabel="true"
              >{{ lmodel.ambEnterStaticCode }}</label
            >
            <InputRequiredText
              v-model="vmodel1.ambCustomerStaticCode"
              id="CustomerStaticCode"
              PropName="Static Code Value"
              :placeholder="lmodel.ambEnterStaticCodePlaceholder"
              :disabled="dealStatus != 3"
              :validation="valmodel.ambCustomerStaticCode"
              class="mt-1 mb-1"
            ></InputRequiredText>
          </div>
          <div class="col-12 lg:col-7"></div>
          <div
            class="col-12 lg:col-5"
            v-show="
              vmodel1.ambCustomerStaticCode &&
              $store.state.cognitoInfo.role == 'Superadmin' &&
              $route.name !== 'ManageDealUpdateCreate'
            "
          >
            <PrimeButton
              class="btn-change"
              type="button"
              tabindex="-1"
              label="Change"
              @click="popupCall()"
            ></PrimeButton>
          </div>
        </div>
      </div>

      <div class="grid line-text">
        <div class="col-12 lg:col-7"></div>
        <div class="col-12 lg:col-5 mobile-swap">
          <Checkbox
            :binary="true"
            id="ambmobileSwipe"
            v-model="vmodel1.ambMobileSwipe"
            type="checkbox"
            class
          />
          <label
            for="ambmobileSwipe"
            class="ml-2 checkbox-radio-font"
            id="ambmobileSwipe-tooltip"
            >{{ lmodel.ambMobileSwipe }}</label
          >
        </div>
      </div>

      <div class="grid mt-2 line-text" v-if="vmodel1.ambMobileSwipe">
        <div class="col-12 lg:col-5">
          <label
            class="control-labeladd"
            for="ambSwipemodalheaderToolTip-tooltip"
            :isRequiredLabel="false"
            >{{ lmodel.ambSwipemodalheader }}</label
          >
          <InputText
            v-model="vmodel1.ambswipemodalheader"
            type="text"
            autocomplete="off"
            :placeholder="lmodel.ambSwipemodalheaderPlaceholder"
            class="mt-2"
            id="ambSwipemodalheader"
          />
        </div>
        <div class="col-12 lg:col-2"></div>
        <div class="col-12 lg:col-5">
          <label
            class="control-labeladd"
            for="swipemodaltext-tooltip"
            :isRequiredLabel="false"
            >{{ lmodel.ambSwipemodaltext }}</label
          >
          <InputText
            v-model="vmodel1.ambswipemodaltext"
            type="text"
            autocomplete="off"
            :placeholder="lmodel.ambSwipemodaltextPlaceholder"
            class="mt-2"
            id="swipemodaltext"
          />
        </div>
      </div>
      <div class="grid line-text" v-if="vmodel1.ambMobileSwipe">
        <div class="col-12 lg:col-5">
          <label
            for="swipemodalcode-tooltip"
            class="control-labeladd"
            :isRequiredLabel="false"
            >{{ lmodel.ambSwipemodalcode }}</label
          >
          <InputRequiredText
            v-model="vmodel1.ambswipemodalccode"
            PropName="Confirmation Code"
            id="swipemodalcode"
            MinValue="0"
            MaxValue="9999999999999999999"
          />
        </div>
        <div class="col-12 lg:col-2"></div>
        <div class="col-12 lg:col-5">
          <label-tooltip
            :labelvalue="lmodel.ambSwipebtnexpand"
            tooltipvalueFor="swipebtnexpand-tooltip"
            :tooltipvalue="lmodel.ambSwipebtnexpandToolTip"
            labelclass="control-labeladd"
            :isRequiredLabel="false"
          ></label-tooltip>
          <InputText v-model="vmodel1.ambswipebtnexpand" id="swipebtnexpand" />
        </div>
      </div>
      <div class="grid line-text" v-if="vmodel1.ambMobileSwipe">
        <div class="col-12 lg:col-5">
          <label-tooltip
            :labelvalue="lmodel.ambSwipebtncancel"
            tooltipvalueFor="swipebtncancel-tooltip"
            :tooltipvalue="lmodel.ambSwipebtncancelToolTip"
            labelclass="control-labeladd"
            :isRequiredLabel="false"
          ></label-tooltip>
          <InputText v-model="vmodel1.ambSwipebtncancel" id="swipebtncancel" />
        </div>
      </div>
      <div class="border-line mt-4" v-if="vmodel1.ambRewardtype > -1"></div>

      <div class="grid mt-2 line-text" v-if="vmodel1.ambRewardtype > -1">
        <div class="col-12 lg:col-7 label-container">
          <label
            for="Ambassadorrewardtiming"
            class="control-labeladd"
            v-tooltip="lmodel.ambassadorRewardTimeToolTip"
            >{{ lmodel.ambassadorRewardTime }}</label
          >
        </div>
        <div class="col-12 lg:col-5">
          <DropDownRequire
            :validation="valmodel.ambAmbassadorRewardTime"
            v-model="vmodel1.ambAmbassadorRewardTime"
            :options="ambassadorRewardTimeOptionList"
            PropName="Ambassador Reward Time"
            id="AmbassadorRewardTime"
            :placeholder="lmodel.ambassadorRewardTimePlaceholder"
            class="mt-1 inline-block"
            optionLabel="text"
            optionValue="value"
            dropdownIcon="fa fa-sort"
            editable
          ></DropDownRequire>
        </div>
      </div>
      <div class="border-line mt-3" v-if="vmodel1.ambRewardtype > -1"></div>
      <div class="grid line-text mt-1" v-if="vmodel1.ambRewardtype > -1">
        <div class="col-12 lg:col-12">
          <h5 class="text-bold">
            {{ lmodel.ambExpirationDateReminderTitle }}
            <br />
            <small>{{ lmodel.ambExpirationDateReminderTitleSmall }}</small>
          </h5>
        </div>

        <div class="col-12 lg:col-12">
          <label
            class="control-label"
            id="ambDealValidity-tooltip"
            v-tooltip="lmodel.ambDealValidityToolTip"
            >{{ lmodel.ambDealValidity }}</label
          >
        </div>

        <div class="col-12 lg:col-6">
          <RadioButton
            id="customerIsTimeSpanCoupon_true"
            v-model="vmodel1.ambCustomerIsTimeSpanCoupon"
            type="radio"
            :value="true"
            @change="dealValidity"
          />
          <label
            class="ml-2 checkbox-radio-font"
            for="customerIsTimeSpanCoupon_true"
          >
            <b>{{ lmodel.ambDealValidityDays }}</b>
          </label>
        </div>
        <div class="col-12 lg:col-6 custom-control custom-radio">
          <RadioButton
            id="customerIsTimeSpanCoupon_false"
            v-model="vmodel1.ambCustomerIsTimeSpanCoupon"
            type="radio"
            :value="false"
            @change="dealValidity"
          />
          <label
            class="ml-2 checkbox-radio-font"
            for="customerIsTimeSpanCoupon_false"
          >
            <b>{{ lmodel.ambDealValidityDate }}</b>
          </label>
        </div>

        <div class="col-12 lg:col-6">
          <InputRequiredNumber
            :validation="valmodel.ambCustomerTimeSpanDaysAmount"
            v-model="vmodel1.ambCustomerTimeSpanDaysAmount"
            id="ambCustomerTimeSpanDaysAmount"
            PropName="Amount of Days"
            :placeholder="lmodel.ambTimeSpanDaysAmountPlaceholder"
            MinValue="0"
            class="w-full"
            :disabled="
              vmodel1.ambCustomerIsTimeSpanCoupon == false ||
              vmodel1.ambEnableDealToCustomer == true
            "
          ></InputRequiredNumber>
          <input type="hidden" v-model="customerTimeSpanDaysAmount2" />
        </div>

        <div class="col-12 lg:col-6">
          <Calendar
            v-model="vmodel1.ambcustomerCodeExpirationDate"
            id="customerCodeExpirationDate"
            :placeholder="lmodel.ambCodeExpirationDatePlaceholder"
            showTime
            hourFormat="24"
            dateFormat="yy-mm-dd"
            showIcon
            :minDate="new Date()"
            :disabled="
              vmodel1.ambCustomerIsTimeSpanCoupon == true ||
              vmodel1.ambEnableDealToCustomer == false
            "
            :disabledDates="invalidDates"
            class="w-full calBorder calInput"
            @update:modelValue="changeExpiryDate()"
          ></Calendar>
        </div>
      </div>
      <div class="border-line mt-3" v-if="vmodel1.ambRewardtype > -1"></div>

      <div
        :class="
          !isDisabled
            ? 'header-edit-mode text-right button-container'
            : 'head-mode text-right button-container'
        "
      >
        <PrimeButton
          id="cancelbtn"
          @click="cancelBtn()"
          type="button"
          name="Cancel"
          value="cancel"
          label="Cancel"
          class="cancel-btnadd"
        />
        <PrimeButton
          label="Save"
          class="save-btn1 ml-2 mr-2"
          icon="save-icon"
          @click="saveReward()"
        ></PrimeButton>
      </div>
      <Dialog
        position="top"
        v-model:visible="ShowChangePopup"
        :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
        :style="{ width: '500px', height: '20vw' }"
        class="popup"
      >
        <h2 class="text-center">{{ lmodel.changeStaticCode }}</h2>
        <div class="row mt-2">
          <div class="col-12 mt-4">
            <label class="mt-2">{{ lmodel.code }}</label>
            <input
              v-model="vmodel1.ambCustomerStaticCode"
              id="staticCode"
              class="w-full mt-2"
              PropName="Static Code Value"
              :placeholder="lmodel.friEnterStaticCodePlaceholder"
            />
            <PrimeButton
              class="btn-change"
              type="button"
              style="margin-top: 13px; margin-left: 398px"
              tabindex="-1"
              label="Apply"
              id="send-mail"
              formnovalidate
              @click="replaceStaticCode"
            ></PrimeButton>
          </div>
        </div>
      </Dialog>
    </div>

    <div v-if="(isRwd && isDisabled) || (isSave && !isRwd)">
      <div class="grid line-text">
        <div class="col-12 lg:col-3">
          <label for="rewardType" class="control-labelextra">
            {{ staticData.rewards.rwdtype }}
          </label>
        </div>
        <div class="col-12 lg:col-7">
          <label for="rewardType1" class="control-labeladd">
            {{ staticData.rewards.voyadopromo }}
          </label>
        </div>
      </div>
      <div class="grid line-text">
        <div class="col-12 lg:col-3">
          <label for="Voyadopromotion" class="control-labelextra">
            {{ staticData.rewards.voyadopromo }}
          </label>
        </div>
        <div class="col-12 lg:col-7">
          <label for="Promotionid" class="control-labeladd">
            {{ staticData.rewards.voyadopromoid }}
          </label>
        </div>
      </div>
      <div class="grid line-text-2">
        <div class="col-12 lg:col-3">
          <label for="ambrwdtiming" class="control-labelextra">
            {{ staticData.rewards.ambrwdtiming }}
          </label>
        </div>
        <div class="col-12 lg:col-7">
          <label for="dateid" class="control-labeladd">
            {{ staticData.rewards.voyadodatedata }}
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataLayerService from "@/services/data-layer.service.js";
import LabelTooltip from "@/components/shared/label-tooltip.vue";
import staticData from "@/staticdata/static.json";
import Dialog from "primevue/dialog";
import moment from "moment";
export default {
  emits: ["openGetMeCodePopup", "exportUnusedCode", "call", "cancel"],

  components: {
    "label-tooltip": LabelTooltip,
    Dialog,
  },

  props: {
    dealId: {
      type: String,
      default: null,
    },
    siteId: {
      type: String,
      default: null,
    },
    isCancelClick: {
      type: Boolean,
      default: false,
    },
    tabId: {
      type: Number,
      default: 0,
    },
    lmodel: {
      type: Object,
      default: null,
    },
    dmodel: {
      type: Object,
      default: null,
    },
    vmodel: {
      type: Object,
      default: null,
    },
    valmodel: {
      type: Object,
      default: null,
    },
    dealStatus: {
      type: Number,
      default: null,
    },
    isRedealText: {
      type: Boolean,
      default: false,
    },
    customerCampaignDealyDaysError: {
      type: String,
      default: null,
    },
    modelstate: {
      type: Object,
      default: null,
    },
    disableReferral: {
      type: Boolean,
      default: false,
    },
    friendCampaignDealyDaysError: {
      type: String,
      default: null,
    },
    isRwd: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    enableRewardSection: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      uniquecodedropdown: "",
      replacefiledropdown: "",

      customerTimeSpanDaysAmount2: 0,
      staticData: staticData,
      isEnable: false,
      isEditMode: false,
      isSave: false,
      showEmbedWidget: false,
      colorPickerOpen: {
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false,
      },
      isreward: false,
      redirectToUrl: "",
      opnNextDealByTag: "",
      todayDt: moment(),
      isExpirationDateValid: null,
      hiddenInputValue: null,
      lastCustomerTimeSpanDaysAmount: null,
      errorMessageFri: true,
      catchErrorFri: "",
      id: "663c88808f6354bc3029a093",
      separatorExp: /,| /,
      staticCodeText: "",
      CodeExpirationDatePickerOpen: false,
      mailType: "",
      emailAddress: "",
      showPopup: false,
      invalidDates: null,
      codesresponse: "",
      isUnqiueCode: false,
      ShowChangePopup: false,
    };
  },
  computed: {
    vmodel1: {
      get() {
        return this.vmodel;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    ambassadorRewardTimeOptionList() {
      let options = this.dmodel.ambassadorFriend.ambassadorRewardTimeList;
      if (this.vmodel1?.disablereferrals) {
        return options.filter((x) => x.value == 0 || x.value == -1);
      }
      return options;
    },
  },
  mounted() {
    if (this.vmodel1?.ambdynamicCodesFileListItems?.length > 0) {
      this.uniquecodedropdown =
        this.vmodel1.ambdynamicCodesFileListItems[0].text;
    } else {
      this.uniquecodedropdown = this.vmodel1.ambdynamicCodesFileListItems;
    }
    if (this.vmodel1?.ambreplacefiles?.length > 0) {
      this.replacefiledropdown = this.vmodel1.ambreplacefiles[0].text;
    } else {
      this.replacefiledropdown = this.vmodel1.ambreplacefiles;
    }

    document.addEventListener("click", this.handleOutsideClick);

    if (
      this.vmodel1.ambEnableDealToCustomer == false &&
      (this.vmodel1.ambCustomerStaticCode == null ||
        this.vmodel1.ambCustomerStaticCode == "")
    ) {
      this.vmodel1.ambCustomerStaticCode = "#";
    }
    // this.vmodel1.ambisVoyadoPromo = false;
    // if (this.$route.name !== "CopyDeal") {
    //   if (
    //     ((this.vmodel1.ambVoyadoPromoId !== "" &&
    //       this.vmodel1.ambVoyadoPromoId !== null &&
    //       this.vmodel1.ambVoyadoPromoId !== undefined) ||
    //       this.vmodel1.ambvoyadoReward == true) &&
    //     (this.vmodel1.ambCustomerStaticCode == null ||
    //       this.vmodel1.ambCustomerStaticCode == "") &&
    //     (this.vmodel1.ambcustomerUseDynamicCodes == null ||
    //       this.vmodel1.ambcustomerUseDynamicCodes == "")
    //   ) {
    //     this.vmodel1.ambVoyadoPromoId = true;
    //     this.vmodel1.ambrewardtype = 2;
    //   } else if (this.vmodel.ambcustomerUseDynamicCodes == true) {
    //     this.vmodel1.ambrewardtype = 1;
    //   }
    // }
  },
  created() {},

  beforeUnmount() {
    document.removeEventListener("click", this.handleOutsideClick);
  },
  methods: {
    downloadCSV() {
      const selectedOption = this.uniquecodedropdown;
      // console.log(selectedOption,"11");
      window.open(selectedOption, "_blank");
    },
    downloadCSVreplacefile() {
      const selectedOptionReplace = this.replacefiledropdown;
      // console.log(selectedOption,"11");
      window.open(selectedOptionReplace, "_blank");
    },
    changeExpiryDate() {
      if (this.vmodel1.ambcustomerCodeExpirationDate) {
        let customerCodeExpirationDate = new Date(
          this.vmodel1.ambcustomerCodeExpirationDate
        );
        let todayDate = new Date();

        // Calculate the difference in milliseconds
        let timeDifference =
          customerCodeExpirationDate.getTime() - todayDate.getTime();

        // Convert milliseconds to days
        let diffDays = Math.ceil(timeDifference / (1000 * 3600 * 24));

        console.log(diffDays, "diffDays");

        // if (diffDays > this.vmodel1.customerRemindBeforeDays) {
        //   console.log("this is greater");
        // }
      }
    },

    popupCall() {
      this.ShowChangePopup = true;
    },
    cancelBtn() {
      this.$emit("cancel");
    },
    saveReward() {
      this.$emit("call");

      this.isSave = true;
    },
    EditData() {
      this.isEditMode = true;
    },
    dealValidity() {
      if (this.vmodel1.ambCustomerIsTimeSpanCoupon == false) {
        this.customerTimeSpanDaysAmount2 =
          this.vmodel1.ambCustomerTimeSpanDaysAmount;
        this.vmodel1.customerTimeSpanDaysAmount = 0;
      } else if (this.vmodel1.ambCustomerIsTimeSpanCoupon == true) {
        this.vmodel1.ambCustomerTimeSpanDaysAmount =
          this.customerTimeSpanDaysAmount2;
      }
    },
    closePopup() {
      this.showPopup = false;
    },
    unselectCheckValue() {
      if (this.vmodel1.friend.friendRewardTime == "0") {
        this.vmodel1.friend.hideOptinFriend = false;
      } else if (this.vmodel1.friend.friendRewardTime == "1") {
        this.vmodel1.friend.isShowFriendCode = false;
      }
    },

    showPreviewPopup(mailType) {
      this.mailType = mailType;
      this.showPopup = true;
    },

    replaceStaticCode() {
      const model = {
        DealId: this.id,
        CouponCode: this.vmodel1.ambCustomerStaticCode,
        CouponType: 0,
      };
      DataLayerService.post("/deal/ReplaceStaticCoupon", model).then((res) => {
        if (res.success) {
          // this.vmodel1.customerStaticCode = this.staticCodeText;
          this.ShowChangePopup = false;
          this.$toast.add({
            detail: "Static code changed successfully",
            severity: "success",
            life: 3000,
          });
        }
      });
    },
    showIdentiUser() {
      if (this.vmodel1.showunidentiuser == true) {
        this.vmodel1.showidentiuser = false;
      }
    },
    showUnIdentiUser() {
      if (this.vmodel1.showidentiuser == true) {
        this.vmodel1.showunidentiuser = false;
      }
    },

    handleGetMeCodePopup() {
      this.$emit("openGetMeCodePopup", true);
    },
    exportUnusedCode() {
      this.$emit("exportUnusedCode", true, "ambassador");
    },

    handleCheckboxClick(value) {
      const index = this.vmodel1.dealTriggers.indexOf(value);
      if (index > -1) {
        this.vmodel1.dealTriggers.splice(index, 1);
      } else {
        this.vmodel1.dealTriggers = [value];
        const checkboxes = document.getElementsByClassName("test");
        checkboxes.forEach((checkbox) => {
          if (checkbox.value !== value) {
            checkbox.checked = false;
            this.vmodel1.pathKeyValue.key = "";
            this.vmodel1.pathKeyValue.value = "";
          } else {
            checkbox.checked = true;
          }
        });
      }
    },

    changeEventofUseDynamicCode(rewardId) {
      this.vmodel1.ambRewardtype = rewardId;
      if (this.vmodel1.ambRewardtype == 0) {
        this.vmodel1.ambCustomerUseDynamicCodes = false;
        this.vmodel1.ambisVoyadoPromo = false;
      }
      if (this.vmodel1.ambRewardtype == 1) {
        this.vmodel1.ambCustomerUseDynamicCodes = true;
        this.vmodel1.ambisVoyadoPromo = false;
      }
      if (this.vmodel1.ambRewardtype == 2) {
        this.vmodel1.ambshowVoyadoPromo = true;
        this.vmodel1.ambisVoyadoPromo = true;
        this.vmodel1.ambvoyadoReward = true;
      }
      if (this.vmodel1.ambRewardtype == 0) {
        this.vmodel1.ambCustomerStaticCode = null;
        this.vmodel1.ambCustomerEANBarCodeText = null;
        this.vmodel1.ambCustomerBarcodeImg = null;
        this.vmodel1.ambCustomerBarcodeImgFileName = null;
        this.vmodel1.ambCustomerLowCodeLimit =
          this.vmodel1.ambCustomerLowCodeLimitDefault;
        this.vmodel1.ambCustomerLowCodeAlertLimit =
          this.vmodel1.ambCustomerLowCodeAlertLimitDefault;
      }
      if (this.vmodel1.ambRewardtype == 1) {
        this.vmodel1.ambCustomerDynamicCodesActualFilename = null;
        this.vmodel1.ambCustomerDynamicCodesFilename = null;
        this.vmodel1.ambCustomerDynamicCodesFullPath = null;
        this.vmodel1.ambCustomerDynamicCodesStream = null;
      }
      if (this.vmodel1.ambRewardtype == 2) {
        this.vmodel1.ambVoyadoPromoId = null;
        this.vmodel1.ambvoyadobonuspoint = null;
      }
    },

    handleDynamicCodes(event) {
      this.vmodel1.ambCustomerUseDynamicCodes = true;
      const selectedFiles = event.files;
      for (let i = 0; i < selectedFiles.length; i++) {
        const reader = new FileReader();
        reader.onload = () => {
          this.vmodel1.ambCustomerDynamicCodesStream = reader.result;
          this.vmodel1.ambCustomerDynamicCodesActualFilename =
            selectedFiles[i].name;
        };

        reader.readAsDataURL(selectedFiles[i]);
      }
    },

    handleBarcodeChange() {
      if (
        this.vmodel1.ambCustomerEANBarCodeText !=
        this.vmodel1.ambCustomerEANBarCodeTextExisting
      ) {
        this.vmodel1.ambCustomerBarcodeImgFileName = null;
      }
    },
    //Expanded Image (Desktop)

    replaceDynamicCodes(event) {
      const eventOfFile = event;
      const file = event.files[0];
      const codes = this.vmodel1.ambCustomerTotalCodesUpdate;
      const id = this.$route.params.id;
      this.codesresponse = this.vmodel1.ambCustomerCodesUpdate;

      const readerNew = new FileReader();
      readerNew.addEventListener(
        "load",
        function () {
          this.base64 = readerNew.result;
        }.bind(this),
        false
      );
      readerNew.readAsDataURL(file);

      const reader = new FileReader();
      reader.readAsText(file);

      reader.onload = (event) => {
        const csv = event.target.result;
        const rows = csv.split("\r\n");
        const array = [];
        const rowsOfLength = rows.length;

        const totalCustomerCodes = parseInt(codes);
        if (rowsOfLength < totalCustomerCodes) {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Codes should greater than Customer Code",
            life: 3000,
          });
          eventOfFile.value = null;
          this.$refs.file1.clear();
          return false;
        } else {
          for (let i = 1; i < rows.length; i++) {
            const cols = rows[i].split(",");
            for (let j = 0; j < cols.length; j++) {
              array.push(cols[j]);
            }
          }
          if (array != null && array.length > 0) {
            const model = {
              DealId: id,
              CouponType: 0,
              ListOfCoupon: array,
              codestream: readerNew.result,
              filename: file.name,
            };
            DataLayerService.post("/deal/ReplaceCoupon", model).then((res) => {
              this.codesresponse = res.data;
              eventOfFile.value = null;
            });
          }
        }
      };
    },
  },
};
</script>

<style lang="scss" scoped>
input:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none !important;
  border: #c0c0bc !important;
  outline: 2px solid #222222 !important;
  border-style: double !important;
}
.p-inputtext:enabled:focus {
  outline: 0 none !important;
  outline-offset: 0 !important;
  box-shadow: none !important;
  border: #c0c0bc !important;
  outline: 2px solid #222222 !important;
  border-style: double !important;
}

.p-button:enabled:hover {
  background-color: #2d6e6d;
  border-color: #2d6e6d;
  color: #fff;
}

input {
  color: #777 !important;
  font-size: 0.8rem;
  height: calc(1.5em + 0.75rem + 7px);
  width: 100%;
  box-shadow: none;
  border: 1px solid #c0c0bc;
  border-radius: 0.25rem;
  font-weight: 400;
  line-height: 1.5;
  padding: 0.375rem 0.75rem;
  font-family: "Voyado Text";
}
:deep(.p-inputtext) {
  color: #21211f !important;
  font-size: 16px;
  height: calc(1.5em + 0.75rem + 7px);
  width: 100%;
  box-shadow: none;
  border-radius: 0.25rem;
  font-weight: 400;
  line-height: 1.5;
  padding: 0.375rem 0.75rem;
  font-family: "Voyado Text";
}
:deep(.p-inputtext:enabled:focus) {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none;
}

:deep(.browse-button) {
  color: #ffffff;
  background: #2d6e6d !important;
  border-color: #2d6e6d !important;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  height: 37px;
  // opacity: 0.65;
  text-align: center;
  vertical-align: middle;
  border: 1px solid transparent;
  box-shadow: none;
  width: 100%;
  font-family: "Voyado Text";
}
.browse-button :hover {
  background: #2d6e6d !important;
  border-color: #2d6e6d !important;
}
.checkbox-radio-font {
  font-size: 14.22px;
}

:deep(.calBorder) {
  .p-button {
    border: 1px solid #c0c0bc !important;
    border-left: none !important;
  }
}
:deep(.p-calendar .p-button) {
  color: #000;
  background: #fff;
  border-top: 1px solid #c0c0bc;
  border-right: 1px solid #c0c0bc;
  border-bottom: 1px solid #c0c0bc;
  border-left: transparent !important;
  padding: 0 !important;
  -webkit-box-shadow: none;
  box-shadow: none;
}

:deep(.p-calendar .p-button:hover) {
  color: #000;
  background: #fff;
  border-top: 1px solid #c0c0bc;
  border-right: 1px solid #c0c0bc;
  border-bottom: 1px solid #c0c0bc;
  border-left: transparent !important;
  padding: 0 !important;
}
:deep(.p-calendar-w-btn .p-inputtext) {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-right: none !important;
}
:deep(.calInput) {
  .p-inputtext {
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0rem;
    border-bottom-right-radius: 0rem;
  }
}

:deep(.inputnumfocus) {
  .p-inputtext:enabled:focus {
    outline: 0 none;
    outline-offset: 0;
    box-shadow: none !important;
    border: #c0c0bc !important;
    outline: 2px solid #222222 !important;
    border-style: double !important;
  }
}

:deep(.input-wrapper input:focus) {
  outline: 1px solid black;
  border-radius: 4px;
  outline: none;
}

.p-inputgroup > .p-inputwrapper:last-child > .p-inputtext {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.p-inputgroup > input:first-child {
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px;
}

.fa {
  margin-left: auto !important;
}

.header-text {
  display: flex;
  align-items: center;
  height: auto;
  padding: 26px 40px 26px 40px;
  border-radius: 4px 4px 0px 0px;
}

.header-text span {
  display: block;
  margin-top: 5px;
}

.toggle-button {
  display: flex;
  align-items: center;
}

.toggle-button span {
  cursor: pointer;
  vertical-align: middle;
}

.col-4 {
  grid-column: span 4;
}
.col-8 {
  grid-column: span 8;
}

.border-box {
  border: 1px solid #c0c0bc;
  height: 40px;
  display: flex;
  border-radius: 4px;
  margin-left: 50px;
}

.voyadopromo-box {
  height: 40px !important;
  gap: 10px !important;
  border-radius: 4px 0px 0px 0px !important;
  border: 1px 0px 0px 0px !important;
}

.mobile-swap {
  height: 35px !important;
}
.line-text {
  align-items: center;
  padding: 0px 32px 0px 32px !important;
}
.line-text-2 {
  align-items: center;
  padding: 0px 32px 15px 32px;
}

.button-container {
  padding: 26px 40px 26px 40px;
}

:deep(.p-button:focus) {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none !important;
}

.header-edit-mode {
  background-color: #f8f8f7 !important;
}
.head-mode {
  background-color: #fff !important;
}

:deep(.heading-text) {
  height: 19px;
  font-family: "Voyado Text";
  font-size: 16px;
  font-weight: 600;
  line-height: 19.2px;
  text-align: left;
  color: #21211f;
}
.container-text {
  font-family: "Voyado Text";
  font-size: 14.22px;
  font-weight: 400;
  line-height: 17.07px;
  text-align: left;
  color: #21211f;
}
.btn-change {
  background-color: #2d6e6d;
  border-color: #2d6e6d;
  color: #fff;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
  display: inline-block;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
}

.header-edit-mode {
  background-color: #f8f8f7 !important;
  // background: rgb(156, 119, 148) !important;
}

.head-mode {
  background-color: #fff !important;
}
.text-bold {
  font-weight: 600 !important;
}
:deep(.control-label) {
  font-size: 14.22px;
}
</style>
